import o from "../../node_modules/classnames/index.js";
import { jsx as t } from "../../_virtual/jsx-runtime.js";
function s({
  className: r,
  children: m
}) {
  return /* @__PURE__ */ t("div", {
    className: o("form-grid__title", r),
    children: m
  });
}
export {
  s as FormTitle
};
//# sourceMappingURL=FormTitle.js.map
